import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import Courses from "./Courses/Courses"
import CustomAddCourse from "./Courses/CustomAddCourses"
import Announcements from "./Announcements/Announcements.jsx"
import AddAnnouncements from "./Announcements/AddAnnouncements.jsx"
import Settings from "./Settings/Settings"
import CustomAddQuizzes from "./Quiz/CustomAddQuizzes"
import Quiz from "./Quiz/Quiz"
import CustomAddTopic from "./Topics/CustomAddTopics"
import Topics from "./Topics/Topics"
import Reports from "./Reports/Reports"
import Dashboard from "./Dashboard/Dashboard"
import LiveCourses from "./LiveCourses/LiveCourses"
import CustomAddLiveCourse from "./LiveCourses/CustomAddLiveCourses"
import CourseDetails from "./CourseDetails/CourseDetails"
import Login from "./Login/Login"
import CourseDashboard from "./Course Dashboard/CourseDashboard"
import WithLayout from "./RouterNavigation/WithLayout"
import NotFound from "./NotFound"

export default function App() {
    return (
        <Router>
            <Switch>
                <Route exact path='/login'>
                    <Login />
                </Route>
                <PrivateRoute exact path='/'>
                    <Redirect to='/dashboard' />
                </PrivateRoute>
                <PrivateRoute exact path='/courses' component = {WithLayout(Courses)}/>
                <PrivateRoute exact path='/courses/:id' component={WithLayout(CourseDetails)} />
                <PrivateRoute exact path='/course-dashboard/:id' component={WithLayout(CourseDashboard)} />
                <PrivateRoute exact path='/add-courses' component = {WithLayout(CustomAddCourse)} />
                <PrivateRoute exact path='/topics' component = {WithLayout(Topics)} />
                <PrivateRoute exact path='/add-topics' component = {WithLayout(CustomAddTopic)} />
                <PrivateRoute exact path='/announcements' component ={WithLayout(Announcements)} />
                <PrivateRoute exact path='/add-announcements' component = {WithLayout(AddAnnouncements)} />
                <PrivateRoute exact path='/settings' component = {WithLayout(Settings)} />
                <PrivateRoute exact path='/quizzes' component = {WithLayout(Quiz)} />
                <PrivateRoute exact path='/add-quizzes' component = {WithLayout(CustomAddQuizzes)} />
                <PrivateRoute exact path='/live-courses' component = {WithLayout(LiveCourses)} />
                <PrivateRoute exact path='/add-live-courses' component = {WithLayout(CustomAddLiveCourse)} />
                <PrivateRoute exact path='/reports' component = {WithLayout(Reports)} />
                <PrivateRoute exact path='/dashboard' component = {WithLayout(Dashboard)} />
                <PrivateRoute path='*' component={WithLayout(NotFound)} />
                </Switch>
        </Router>
    )
}

function PrivateRoute({ children, component: Component, ...rest }) {

    return (
        <Route
            {...rest}
            render={(props) =>
                window.localStorage.getItem("user") ? (
                    <Component {...props}  />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
}